import type { ChartConfig } from "@/components/ui/chart";
import type { Choice } from "./choiceSelection";
import { MULTIPLE_COLORS, YES_NO_COLORS } from "./constants";

/**
 * Create chart configuration for selected lines with fixed colors based on choice order
 */
export const createChartConfig = (allChoices: Choice[]): ChartConfig => {
  const config: ChartConfig = {};

  // Determine color palette based on total number of choices
  let colors: string[];
  if (allChoices.length === 2) {
    colors = YES_NO_COLORS;
  } else if (allChoices.length >= 20) {
    colors = ["#000000"]; // Black for 20+ choices
  } else {
    colors = MULTIPLE_COLORS;
  }

  // Assign fixed colors based on sorted choice order
  allChoices.forEach((choice, index) => {
    const colorIndex = allChoices.length >= 20 ? 0 : index % colors.length;
    config[choice.id] = {
      label: choice.name,
      color: colors[colorIndex],
    };
  });

  return config;
};
